import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Input } from '@zep/ui/experimental';
export const MissingFeatureContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    register,
    resetField
  } = useFormContext();
  useEffect(() => {
    return () => {
      resetField('missingFeatures');
    };
  }, [resetField]);
  return <div className="flex flex-col gap-[8px]" data-sentry-component="MissingFeatureContent" data-sentry-source-file="MissingFeatureContent.tsx">
      <p className="text-body-2-m whitespace-pre text-wrap text-gray-600">
        {t('subscription:unsubscribe.21066a10', '어떤 기능이 필요하셨나요? 구체적으로 작성해 주시면 서비스 개선에 적극 반영하겠습니다.')}
      </p>
      <Input className="h-[40px] w-full" placeholder={t('subscription:unsubscribe.f8e9dc74', '필요하셨던 기능을 입력해 주세요 (필수)')} {...register('missingFeatures')} data-sentry-element="Input" data-sentry-source-file="MissingFeatureContent.tsx" />
    </div>;
};